// extracted by mini-css-extract-plugin
module.exports = {"store-category":"SelectStoreCategory_store-category__1nZ7h"};